/**
 * Coerce money from API or UI to a float for formatting.
 * Stored values use "." as decimal; European-style strings may use "," as decimal
 * (e.g. "1.234,56"). currency.js would mis-parse "5.50" if configured with decimal ",".
 */
export function parseMoneyAmount(value: string | number): number {
  if (typeof value === 'number') {
    return Number.isFinite(value) ? value : 0;
  }

  const s = String(value).trim();
  if (s === '') return 0;

  const lastComma = s.lastIndexOf(',');
  const lastDot = s.lastIndexOf('.');

  // European-style: decimal comma ("5,50" or "1.234,56")
  if (lastComma !== -1 && (lastDot === -1 || lastComma > lastDot)) {
    const normalized = s.replace(/\./g, '').replace(',', '.');
    const n = parseFloat(normalized);
    return Number.isFinite(n) ? n : 0;
  }

  // Canonical / US-style: decimal point ("5.50", "1,234.56")
  const normalized = s.replace(/,/g, '');
  const n = parseFloat(normalized);
  return Number.isFinite(n) ? n : 0;
}
